import {
  BG_02,
  BENTO_GRID_DEFAULTS,
  hideBG02Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

import {
  CATALOG_HOME_LINK_TYPE,
  URL_TYPE_OPTIONS,
} from "@stadium/shared/src/constants/stores/routes";

const FLAG_ITEM_FIELDS = {
  icon: {
    type: "imageUrl",
  },
  alt: {
    type: "string",
  },
};

export const BG02_PLASMIC_PROPS = {
  heading: {
    type: "string",
    defaultValue: BENTO_GRID_DEFAULTS[BG_02].heading,
    description: "Main heading text (BG02 only)",
    hidden: hideBG02Props,
  },
  countryCard: {
    type: "object",
    fields: {
      countryCardHeading: {
        type: "string",
      },
      countryCardDescription: {
        type: "string",
      },
      countryCardBackgroundColor: {
        type: "string",
      },
      countryCardFlags: {
        type: "array",
        itemType: {
          type: "object",
          fields: FLAG_ITEM_FIELDS,
        },
      },
      countryCardWorldImage: {
        type: "imageUrl",
      },
      countryCardWorldImageAlt: {
        type: "string",
      },
    },
    defaultValue: BENTO_GRID_DEFAULTS[BG_02],
    description: "Country card props (BG02 only)",
    hidden: hideBG02Props,
  },
  brandCard: {
    type: "object",
    fields: {
      brandCardLabel: {
        type: "string",
      },
      brandCardCount: {
        type: "string",
      },
      brandCardSubtext: {
        type: "string",
      },
      brandCardButtonText: {
        type: "string",
      },
      brandCardButtonLinkType: {
        type: "choice",
        options: URL_TYPE_OPTIONS,
        defaultValue: CATALOG_HOME_LINK_TYPE,
      },
      brandCardButtonOpenInNewTab: {
        type: "boolean",
        defaultValue: false,
      },
      brandCardButtonOtherUrl: {
        type: "string",
      },
      brandCardButtonCategorySlug: {
        type: "string",
        defaultValue: "",
      },
      brandCardBackgroundColor: {
        type: "string",
      },
      brandCardShirtImage: {
        type: "imageUrl",
      },
      brandCardShirtImageAlt: {
        type: "string",
      },
    },
    defaultValue: BENTO_GRID_DEFAULTS[BG_02],
    description: "Brand card props (BG02 only)",
    hidden: hideBG02Props,
  },
  brandsPlatform: {
    type: "object",
    fields: {
      brandsPlatformHeading: {
        type: "string",
      },
      brandsPlatformBackgroundImage: {
        type: "imageUrl",
      },
      brandsPlatformImageAlt: {
        type: "string",
      },
    },
    defaultValue: BENTO_GRID_DEFAULTS[BG_02],
    description: "Brands platform card props (BG02 only)",
    hidden: hideBG02Props,
  },
  testimonial: {
    type: "object",
    fields: {
      testimonialQuote: {
        type: "string",
      },
      testimonialAuthorName: {
        type: "string",
      },
      testimonialAuthorCompany: {
        type: "string",
      },
      testimonialAuthorImage: {
        type: "imageUrl",
      },
      testimonialAuthorCompanyLogo: {
        type: "imageUrl",
      },
      testimonialAuthorCompanyAlt: {
        type: "string",
      },
      testimonialBackgroundColor: {
        type: "string",
      },
      testimonialSwagmagicMark: {
        type: "imageUrl",
      },
      quotationMark: {
        type: "imageUrl",
      },
    },
    defaultValue: BENTO_GRID_DEFAULTS[BG_02],
    description: "Testimonial card props (BG02 only)",
    hidden: hideBG02Props,
  },
  review: {
    type: "object",
    fields: {
      reviewBackgroundImage: {
        type: "imageUrl",
      },
      reviewImageAlt: {
        type: "string",
      },
      reviewHeading: {
        type: "string",
      },
      reviewButtonText: {
        type: "string",
      },
      reviewButtonUrl: {
        type: "string",
      },
      reviewButtonLinkType: {
        type: "choice",
        options: URL_TYPE_OPTIONS,
        defaultValue: CATALOG_HOME_LINK_TYPE,
      },
      reviewButtonOpenInNewTab: {
        type: "boolean",
        defaultValue: false,
      },
      reviewButtonOtherUrl: {
        type: "string",
      },
      reviewButtonCategorySlug: {
        type: "string",
        defaultValue: "",
      },
    },
    defaultValue: BENTO_GRID_DEFAULTS[BG_02],
    description: "Review card props (BG02 only)",
    hidden: hideBG02Props,
  },
};
